module.exports = __webpack_public_path__ + "media/images/block_4-abda9573a240abb172abcb3564603aa6.png";